import React, { useState } from 'react';
import { Collapse } from 'antd';
import CustomExpandIcon from './CustomExpandIcon';
import CustomAutoCompleteInput from './CustomAutoCompleteInput';
import CheckboxComponent from './CheckboxComponent';
import CustomFilterPanelHeader from './CustomFilterPanelHeader';
import PropTypes from 'prop-types';
import CustomDatePicker from './CustomDatePicker';
import dayjs from '@src/utils/day';
import { useText } from './Text';

const { Panel } = Collapse;

const CustomFilterCollapse = ({ panels, listenClickCheckbox }) => {
  const [activeKey, setActiveKey] = useState(['0']);
  const selectDate2 = useText('selectDate2');

  const handleCollapseChange = (key) => {
    setActiveKey(key);
  };

  const handleOnSelect = (item, setList) => {
    setList(item.name);
  };

  const filterDateChange = async (value, setList) => {
    if (!value) listenClickCheckbox(setList, { start: null, end: null });
    else if (value[0]) {
      const activationDateIso = dayjs(value[0])
        .utcOffset(0)
        .set('hour', 0)
        .set('minute', 0)
        .set('second', 1)
        .toISOString();
      const activationDateIso2 = value[1]
        ? dayjs(value[1])
            .utcOffset(0)
            .set('hour', 23)
            .set('minute', 59)
            .set('second', 59)
            .toISOString()
        : dayjs(value[0])
            .utcOffset(0)
            .set('hour', 23)
            .set('minute', 59)
            .set('second', 59)
            .toISOString();
      setList({ start: activationDateIso, end: activationDateIso2 });
      listenClickCheckbox(setList, { start: activationDateIso, end: activationDateIso2 });
    } else {
      const activationDateIso = dayjs(value)
        .utcOffset(0)
        .set('hour', 9)
        .set('minute', 0)
        .set('second', 0)
        .toISOString();
      setList(activationDateIso);
      listenClickCheckbox(setList, activationDateIso);
    }
  };

  const clickCheckbox = (e, key, list, setList, checkboxStatus = 0) => {
    console.log('checkboxStatus');
    let tempList = [...list];
    if (e.target.checked) {
      if (checkboxStatus === 1) {
        tempList = [];
      }
      tempList.push(key);
    } else {
      tempList = tempList.filter((item) => item !== key);
    }
    setList(tempList);
    listenClickCheckbox(setList, tempList);
  };

  return (
    <Collapse
      onChange={handleCollapseChange}
      activeKey={activeKey}
      expandIconPosition="right"
      expandIcon={CustomExpandIcon}
    >
      {panels?.map((panel) => (
        <Panel
          header={
            panel.input ? (
              panel.text
            ) : (
              <CustomFilterPanelHeader text={panel.text} list={panel.list} />
            )
          }
          className={
            activeKey?.filter((item) => item === panel.key).length > 0
              ? 'custom-demands-dropdown-item-active'
              : 'custom-demands-dropdown-item'
          }
          key={panel.key}
        >
          {panel.input ? (
            <CustomAutoCompleteInput
              items={panel.initialList}
              placeholder={panel.text}
              inputSearchString={panel.defaultValue ? panel.defaultValue : ''}
              handleOnSelect={(e) => handleOnSelect(e, panel.setList)}
              trim={panel.trim}
            />
          ) : panel.date ? (
            <CustomDatePicker
              id={panel.id}
              height={36}
              isRangeDate
              defaultValue={
                panel.defaultValue?.start
                  ? [dayjs(panel.defaultValue.start), dayjs(panel.defaultValue.end)]
                  : null
              }
              placeholder={selectDate2}
              onChange={(value) => filterDateChange(value, panel.setList)}
            />
          ) : (
            panel.initialList?.map((item) => {
              return (
                <CheckboxComponent
                  item={item}
                  key={`${item?.key}-${panel.text}`}
                  list={panel.list}
                  clickCheckbox={(e) =>
                    clickCheckbox(e, item.key, panel.list, panel.setList, panel.checkboxStatus)
                  }
                />
              );
            })
          )}
        </Panel>
      ))}
    </Collapse>
  );
};

CustomFilterCollapse.propTypes = {
  panels: PropTypes.array,
  listenClickCheckbox: PropTypes.func,
};

export default CustomFilterCollapse;
